module.exports = __webpack_public_path__ + "assets/img/driver-btn-45957716.png";